module.exports = __webpack_public_path__ + "static/media/211IT020.696b87b3.jpeg";